const accountI18n = require('./account')
module.exports = {
  // title
  ...accountI18n,
  store: '门店',
  merchant: '商户',
  storeManager: '门店管理',
  businessManager: '营业管理',
  imageManager: '图片管理',
  infoManager: '信息管理',
  financeManager: '财务管理',
  orderManager: '订单管理',
  allOrder: '全部订单',
  addExtraTime: '增加额外时长',
  preOrder: '待接单',
  historyOrder: '历史订单',
  appointmentOrder: '预约单',
  mealPreOrder: '备餐中',
  mealFinish: '备餐完成',
  refundOrder: '取消/退款处理',
  itemManager: '商品管理',
  classfication: '分类列表',
  itemList: '商品列表',
  open: '营业中',
  rest: '休息中',
  pushMessage: '消息推送',
  labelOptions: '标签选项',
  labelCloseOther: '关闭其他',
  labelCloseAll: '关闭所有',
  openShop: '开业',
  notSupport: '不支持',
  within1: '当日内',
  within2: '2日内',
  within3: '3日内',
  within4: '4日内',
  within5: '5日内',
  merchantName: '商户名称',
  showMap: '查看地图',
  menuSetting: '菜单设置',
  addMenu: '添加菜单',
  storeName: '门店名称',
  contactName: '联系人名称',
  contactTel: '联系电话',
  ownedCity: '所属城市',
  coordinate: '坐标',
  longitude: '经度',
  latitude: '纬度',
  storeAddress: '门店地址',
  plan: '展示图',
  envPhoto: '门店环境图',
  storeStatus: '门店状态',
  openDate: '开业时间',
  businessStatus: '营业状态',
  businessDay: '营业日期',
  businessTime: '营业时间',
  paymentMethod: '支付方式',
  mainBusiness: '主营业务',
  businessRange: '经营范围',
  businessType: '业务类型',
  preMealTime: '备餐时长',
  valueAddTax: '商品增值税',
  bookingTime: '可预订单时间',
  startPrice: '起送价',
  speedService: '极速服务',
  basicTime: '基础备餐时长',
  bigTime: '大额备餐时长',
  useActuallyPay: '当用户实付',
  hour: '$',
  openExpress: '开启',
  closeExpress: '关闭',
  today: '当日',
  tomorrow: '次日',
  asOf: '截至',
  newStoreLabel: '新店标签',
  newStore: '新店',
  noNewStore: '非新店',
  switchBusinessStatus: '切换营业状态为休息中，到营业时间将会自动营业,是否确认?',
  sureOpenBusiness: '是否确认开业，开业后不可修改?',
  accountName: '账户名',
  accountBank: '开户行',
  bankAccount: '银行账号',
  serviceCalc: '服务计算基础',
  serviceRate: '服务费率',
  minAmount: '最小提现金额',
  remainingBalance: '余额保留金额',
  WithdrawalMethod: '提现申请方式',
  startDate: '开始日期',
  withdrawalCycle: '提现周期',
  day: '天',
  handApplyWithdrawal: '手动申请提现',
  autoApplayWithdrawal: '自动申请提现',
  nextWithdrawal: '下次自动申请提现日期',
  noHandApplyWithdrawal: '无法进行手动申请提现',
  deleteCategory: '此操作将永久删除这个分类,是否继续？',
  autoRest: '将在{args}自动休息',
  autoBusiness: '将在{args}自动营业',
  noAuto: '不会自动营业/休息，需手动营业/休息',
  search_map: '请输入地址查询',
  storeClosed: '门店停业中',
  storeStopTime: '暂停营业计划',
  endTimeShouldNotGtStartTime: 'ពេលវេលាចាប់ផ្តើមនៃផែនការផ្អាកអាជីវកម្មត្រូវតែធំជាងពេលវេលាបច្ចុប្បន្ន',
  maxsixtyDay: '暂停营业时间间隔最大可设60天',
  stopStoreBusiness: '门店暂停营业中，此时切换状态将会放弃门店暂停营业计划',
  startTimeLimit: '开始时间不得小于当前时间',
  businessTimeLimit: '营业开始时间和营业结束时间不能相同',
  vatCaclMethod: '增值税计算方式',
  packageAmount: '打包费',
  packageAmountTips: '设置打包费将会影响用户下单',
  every: '每',
  caclByMainScope: '根据门店主营业务计算',
  editMenu: '编辑菜单',
  editStock: '编辑库存',
  stockMust: '库存需>=0',
  stockMax: '不得超过最大库存',
  intCheck: '请输入整数',
  noMenu: '无菜单',
  CalculatedMethod: '按[商品原价+包装费+VAT]计算',
  announcementTime: '公告结束时间',
  announcement: '公告',
  largePrepareTimeTip: "每${x}需等待",
  maxMealTimeTip:"// 订单金额>= ${maxmoney}时，将采用最大备餐时间",
  factor: '系数',
  maxPrepareTime: '最大备餐时间',
  submitFail:'提交失败',
  submitFailTip:'尊敬的大象外卖商家，系统检测到您在最近一段时间内营业状态异常，已为您自动休息，如需恢复营业，请联系平台顾问',
  tooShortBusinessHourTitle: '门店营业时长过短',
  tooShortBusinessHourTip: '门店营业时长设置过短，是否继续提交？'
}
